<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form>
        <v-row>
          <h2 class="pb-5">{{ this.parentObject.pageTitle }}</h2>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
          <v-toolbar-title class="subtitle-2">{{$t('statutoryexportcommonused.noparamter')}}</v-toolbar-title>
        </v-container>

        <v-row>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px" @click="backHandler">
              {{$t('button.back')}}
            </v-btn>
          </div>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px" @click="getHLBExportListHandler">
              {{$t('button.export')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import XLSX from 'xlsx/xlsx';
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog,
    Loading,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
      },
      //pageTitle: 'MBB-EMAS-01',

      id: this.parentObject.id,
      data: this.parentObject.data,
      salstatutoryother: null,
      psnstatutoryinfo: [],
      psnpayroll: [],
      titleData: this.parentObject.data.taxsubrecpy[0].payoutdesc,
      statecodeList: [
        {
            text: 'Johor',
            value: '01',
        },
        {
            text: 'Kedah',
            value: '02',
        },
        {
            text: 'Kelantan',
            value: '03',
        },
        {
            text: 'Melaka',
            value: '04',
        },
        {
            text: 'Negeri Sembila',
            value: '05',
        },
        {
            text: 'Pahang',
            value: '06',
        },
        {
            text: 'Pulau Pinang',
            value: '07',
        },
        {
            text: 'Perak',
            value: '08',
        },
        {
            text: 'Perlis',
            value: '09',
        },
        {
            text: 'Selangor',
            value: '10',
        },
        {
            text: 'Terengganu',
            value: '11',
        },
        {
            text: 'Sabah',
            value: '12',
        },
        {
            text: 'Sarawak',
            value: '13',
        },
        {
            text: 'Wilayah Persekutuan (Kuala Lumpur)',
            value: '14',
        },
        {
            text: 'Wilayah Persekutuan (Labuan)',
            value: '15',
        },
        {
            text: 'Wilayah Persekutuan (Putrajaya)',
            value: '16',
        }
      ],

      companyrecnum: "",
      bankcode: "011",
      receivingbank: "",
      paymentref: "",
      paymentdesc: "",
      addr: "",
      filler: "",
      totalAmtStfpcb: null,
      totalAmtCp38: null,
      totalRefno: null,

      accErr: [],
      negErrMsg: [],
      salhdErr: [],
      gettotalAmt: [],
      taxdata: [],
      taxdataholder: [],
      loading: false,

      processedCount: null,
      successCount: null,
      errCount: null,
      exCount: null,
      errMsg: "",
      isErr: false,
      isEdit: this.parentObject.isEdit,
    };
  },

  methods: {
    
    getHLBExportListHandler() {
      this.loading = true;
      const vm = this

      let dateHolder2 = this.data.year + "-" + this.pad(this.data.month, 2) + "-" + this.daysInMonth(this.data.month, this.data.year);
      let date = moment(dateHolder2).format("YYYY-MM-DD");
      this.$store.dispatch('get', {
          url:  `/hlbtaxexport/all/${this.$store.getters.userId}`
          + "/" +  this.data.taxexprecid
          + "/" + this.data.refnum + "/" + date + "/" + date
      })
      .then(function (res) {
        vm.loading = false;

        vm.taxdataholder = res.data.rec;
        vm.exportHandler();
      })
      .catch(function (err) {
        vm.errMsg = err;
      });
    },

    async getData() {
      const vm = this
      let body = []
      let newtaxdetail = []
      let holdpaystfpcb = []
      let holdpaycp38 = []
      let dataholder = vm.taxdataholder
      let taxdetail = this.filter(dataholder);

      this.processedCount = dataholder.length;
      this.successCount = taxdetail.length;
      this.errCount = dataholder.length - taxdetail.length;

      taxdetail.forEach(function (o) {
        var existing = newtaxdetail.filter(function (i) {
          return i.staffcode === o.staffcode;
        })[0];
        if (!existing || existing == undefined) {
          newtaxdetail.push(o);
        } else {
          existing.stfpcb += o.stfpcb;
          existing.cp38 += o.cp38;
        }
      });

      body.push(
        {
          header1: 'Employee Tax Number',
          header2: 'Wife Code', 
          header3: 'Employee Name', 
          header4: 'Employee IC No', 
          header5: 'Employee IC No Old',
          header6: 'Passport No.', 
          header7: 'Country Code', 
          header8: 'PCB Amount',
          header9: 'CP38 Amount', 
          header10: 'Employee Internal ID'
        },
       );

      newtaxdetail.forEach(element => {
        let icnoholder = ''
        let oldicnoholder  = ''
        let docno = ''
        let refno = ''
        let wifecode = ''
        
        // if (element.icno) icnoholder = element.icno.split("-").join("")
        if (element.oldicno) oldicnoholder = element.oldicno
        // if (element.docno) docno = element.docno

        //Wilson: enhancement stated below, priority vw_staff
        if (element.personidnotypeid == 1) { 
          icnoholder = element.personidno.split("-").join("");// id =1 , so it is ic 
        }
        else if (element.personidnotypeid == 3) {
          docno = element.personidno; // if =3 , so passport
        }

        if (element.refno) {
          refno = element.refno.split("SG").join("");
          refno = refno.split("OG").join("");
          refno = refno.split("IG").join("");
          refno = refno.split("-").join("");
        
          wifecode = element.refno.substring(element.refno.length-1, element.refno.length)
          refno = refno.substring(0, element.refno.length-1)
        }

        body.push(
          {
            header1: refno, 
            header2: wifecode, 
            header3: element.psnname, 
            header4: icnoholder.toString(),
            header5: oldicnoholder, 
            header6: docno,
            header7: element.ntlycode, 
            header8: element.stfpcb.toFixed(2), 
            header9: element.cp38.toFixed(2), 
            header10: element.staffcode,
          }
        );
        
        holdpaystfpcb.push(element.stfpcb);
        holdpaycp38.push(element.cp38);
      });

      if (holdpaystfpcb) {
        let totalAmtStfpcbHolder = holdpaystfpcb.reduce(function (a, b) {return a + b}, 0);
        this.totalAmtStfpcb = totalAmtStfpcbHolder.toFixed(2);
      }

      if (holdpaycp38) {
        let totalAmtCp38Holder = holdpaycp38.reduce(function (a, b) {return a + b}, 0);
        this.totalAmtCp38 = totalAmtCp38Holder.toFixed(2);
      }

      if (body.length > 0) {
        const wd =  XLSX.utils.json_to_sheet((body), { origin: 'A1', skipHeader: true});
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, wd,  this.titleData);
        XLSX.writeFile(wb, this.titleData + '.xlsx');
      }
    },

    filter(item) {
      let checkdet = this.detailfilter(item)
      let checkactive = this.activefilter(checkdet)
      let checkpayment = this.paymentfilter(checkactive)
      return checkpayment
    },

    detailfilter(item) {
        let dateHolder = this.data.year + "-" + this.pad(this.data.month, 2) + "-" 
        + this.daysInMonth(this.data.month, this.data.year);
        let date = moment(dateHolder).format("YYYY-MM-DD");
        let dataitem = item.filter(e => e.refnum == this.data.refnum)
        dataitem = dataitem.filter(e => {
            return moment(e.startdate).format("YYYY-MM-DD") <= date && date <= moment(e.enddate).format("YYYY-MM-DD")
        })
        let noacc = item.filter((e) => !dataitem.includes(e));
        for (let i = 0; i < noacc.length; i++) {
            noacc[i].errormsg = this.$t('setupreport_exportmapping.nodetailinpersonstat');
            this.accErr.push(noacc[i]);
        }
        return dataitem
    },

    activefilter(item) {
      let data = item.filter(e => e.pystatcode == 'ACTIVE')
      let notactive = item.filter((e) => !data.includes(e));
      for (let i = 0; i < notactive.length; i++) {
        notactive[i].errormsg = this.$t('setupreport_exportmapping.paymentisnotactive');
        this.accErr.push(notactive[i]);
      }
      return data
    },

    paymentfilter(item) {
      let data = item.filter(e => {
          return e.stfpcb != 0 || e.cp38 != 0 
      })
      let nopayment = item.filter((e) => !data.includes(e));
      for (let i = 0; i < nopayment.length; i++) {
        nopayment[i].errormsg = this.$t('setupreport_exportmapping.nopayment');
        this.accErr.push(nopayment[i]);
      }
      return data
    },

    objectToCSV(header, subheader, data) {
        const csvRows = []

        let headobj = ' ,Employer Tax Number, , , Month,' + header['Month'] + ', , Year,' + header['Year']
        csvRows.push(headobj) 

        for (const row in subheader) {
          csvRows.push(row + ',' + subheader[row])
        }

        csvRows.push([])

        // get header
        const headers = Object.keys(data[0])
        csvRows.push(headers.join(','))

        // loop over the rows
        for (const row of data) {
            const values = headers.map(header => {
                const escaped = ('' + row[header]).replace(/"/g, '\\"')
                return `"${escaped}"`
            })
            csvRows.push(values.join(','))
        }
        return csvRows.join('\n')
    },

    download(data, title) {
      const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", title + ".csv");

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    pad(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },

    exportHandler() {
      this.getData();
      let item = [];
      item.totalAmtstfpcb = this.totalAmtStfpcb;
      item.totalAmtcp38 = this.totalAmtCp38;
      item.accounterr = this.accErr;
      item.successCount = this.successCount;
      item.processedCount = this.processedCount;
      item.errCount = this.errCount;

      if (!this.isErr) {
        this.$router.push({ name: "monthlytaxexportlog", params: { item } });
      }
    },

    backHandler() {
      this.$router.push({ name: "monthlytaxexport" });
    },

    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
  },

  mounted() {
   // this.getHLBExportListHandler();
  },
};
</script>

<style scoped>
</style>